import { getItem, setItem } from '../storage.service';

type InsuranceLike = {
    DIER: {
        pet_code: string;
    };
};

const getStoredValue = async () => {
    const insurance = (await getItem('insurances')) as InsuranceLike;
    return insurance.DIER.pet_code;
};

const setStoredValue = async (petCode: string) => {
    const insurances = ((await getItem('insurances')) as InsuranceLike) ?? { DIER: {} };
    await setItem('insurances', {
        ...insurances,
        DIER: {
            pet_code: petCode
        }
    });
};

const calculatePremium = async (petCode: string, funnelUrl: string) => {
    await setStoredValue(petCode);
    window.location.href = funnelUrl;
};

export { getStoredValue, setStoredValue, calculatePremium };
